/* eslint-disable camelcase */
import axios from 'axios';
import {
  MENU_ENGINEERING_PROFITABILITY_ENDPOINT,
  MENU_ENGINEERING_RECOMMENDATIONS_ENDPOINT,
  MENU_ENGINEERING_RECOMMENDATIONS_LIST_ENDPOINT
} from '@dynameat/constants';

export const menuRecommendationRequest = (menuEngineeringRecommendationGuid) => axios.get(MENU_ENGINEERING_RECOMMENDATIONS_ENDPOINT(menuEngineeringRecommendationGuid));
export const menuRecommendationListRequest = (prediction_period__guid) => axios.get(MENU_ENGINEERING_RECOMMENDATIONS_LIST_ENDPOINT(), { params: { prediction_period__guid, page_size: 0 } });
export const saveMenuRecommendationRequest = (menu_engineering_recommendation_guid, menu_engineering_recommendation) => axios.post(
  MENU_ENGINEERING_RECOMMENDATIONS_ENDPOINT(), menu_engineering_recommendation, { params: { menu_engineering_recommendation_guid } }
);
export const menuEngineeringProfitabilityRequest = (prediction_period_guid, menu_guid = null, section_list = []) => axios.post(
  MENU_ENGINEERING_PROFITABILITY_ENDPOINT(), { prediction_period_guid, menu_guid, section_list } // List of section changes
);
